import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

export type PortHover = { nodeId: string; portId: string } | null;

type PortHoverApi = {
  hovered: PortHover;
  setHovered: (next: PortHover) => void;
};

const PortHoverContext = createContext<PortHoverApi | null>(null);

export function PortHoverProvider({ children }: { children: ReactNode }) {
  const [hovered, setHovered] = useState<PortHover>(null);
  const value = useMemo(() => ({ hovered, setHovered }), [hovered]);
  return <PortHoverContext.Provider value={value}>{children}</PortHoverContext.Provider>;
}

export function usePortHover(): PortHoverApi {
  const ctx = useContext(PortHoverContext);
  if (!ctx) {
    return { hovered: null, setHovered: () => undefined };
  }
  return ctx;
}
